import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const RakutenHotelTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type RakutenHotelTabType = keyof typeof RakutenHotelTab;

const RakutenHotel = observer(() => {
  const history = useHistory();
  const [rakutenHotelTab, setRakutenHotelTab] = useState<RakutenHotelTabType>(
    (utils.getParam('rakuten_hotel_type') as RakutenHotelTabType) ||
      (utils.getParam('rakuten_hotel_tab') as RakutenHotelTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
    if (!currentParams.has('rakuten_hotel_type')) {
      currentParams.set('rakuten_hotel_type', rakutenHotelTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, rakutenHotelTab]);

  const handleTabChange = useCallback(
    (tab: RakutenHotelTabType) => {
      setRakutenHotelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
      currentParams.set('rakuten_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={RakutenHotelTab} currentTab={rakutenHotelTab} onChange={handleTabChange} />
      {rakutenHotelTab === 'ITEMS' ? <Items /> : <Total />}
    </>
  );
});

export default RakutenHotel;
